import styles from './Media.module.css'
import type { VideoConfig } from './types'

interface VideoProps {
  src: string
  config: VideoConfig
}

export const Video = ({ src, config }: VideoProps) => {
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption -- TODO: Add a <track> element to conform to the a11y standards.
    <video
      className={styles.Media__video}
      controls={config.hasControls}
      autoPlay={config.autoplay || !config.hasControls}
      muted={config.isMuted || !config.hasControls}
      loop={config.isLooped}
      src={src}
      preload={!config.autoplay ? 'metadata' : 'auto'}
      poster={config.posterUrl}
      playsInline
    />
  )
}
